import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import { components } from '@glowforge/ui-common';

import './dialog.less';

const { VerticalScrollBox } = components;

// React Modal requires us to register the React root
if (typeof window !== 'undefined') {
  ReactModal.setAppElement(document.querySelector('#react'));
}

const Dialog = ({
  overlayClassName,
  className,
  children,
  title,
  isOpen,
  actionButtons,
  onRequestClose,
  withScrollBox,
  showTopRightCloseButton,
  withPadding,
}) => {
  const content = withScrollBox ? (
    <VerticalScrollBox updateKey={children}>
      { children }
    </VerticalScrollBox>) : children;
  const header = title ? <h3 className='h3'>{title}</h3> : null;
  const topRightCloseButton = showTopRightCloseButton ? <button className='close-button-top-right' onClick={onRequestClose}>✕</button> : null;

  return (
    <ReactModal
      className={classnames('Dialog', className, { withPadding })}
      overlayClassName={classnames('dialogOverlay', overlayClassName)}
      contentLabel={title}
      isOpen={isOpen}
      onRequestClose={onRequestClose} >
      {topRightCloseButton}
      {header}
      {content}
      <div className='actionButtons'>{actionButtons}</div>
    </ReactModal>
  );
};

Dialog.propTypes = {
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onRequestClose: PropTypes.func,
  withScrollBox: PropTypes.bool,
  showTopRightCloseButton: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  actionButtons: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  withPadding: PropTypes.bool,
};

Dialog.defaultProps = {
  className: '',
  overlayClassName: '',
  isOpen: false,
  title: '',
  onRequestClose: null,
  withScrollBox: true,
  showTopRightCloseButton: false,
  actionButtons: null,
  withPadding: false,
};

export default Dialog;



// WEBPACK FOOTER //
// ./app/common/components/dialog.jsx